import * as swcHelpers from '@swc/helpers';

const combineRefetchFunctions = (refetch1, refetch2)=>{
    return swcHelpers.asyncToGenerator(function*() {
        yield Promise.all([
            refetch1(),
            refetch2()
        ]);
    });
};

export { combineRefetchFunctions };
//# sourceMappingURL=combine-refetch-functions.js.map
